import { i18n } from 'boot/i18n';

function translate(object, field) {
  if (object && field && field in object) {
    if (`${field}EN` in object) {
      return i18n.global.locale === 'is' ? object[field] : object[`${field}EN`];
    }
    return object[field];
  }

  return '';
}

function nl2br(str) {
  // eslint-disable-next-line no-useless-concat
  return (`${str}`).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br>');
}

export function translateTitle(object) {
  return translate(object, 'title');
}

export function translateShortDescription(object) {
  return translate(object, 'shortDescription');
}

export function translateDescription(object) {
  return nl2br(translate(object, 'description'));
}
